<template>
	<div
		v-if="thumbnails"
		class="carousel-thumbnail"
		:class="{
			'carousel-thumbnail--unique': thumbnails && thumbnails.length === 1,
			'carousel-thumbnail--default': thumbnails && !thumbnails.length,
			'thumbnail--carousel': thumbnails && thumbnails.length > 1,
		}"
	>
		<helio-link
			v-if="thumbnails && thumbnails.length === 0"
			class="carousel-thumbnail__wrapper"
			:link="link"
		>
			<helio-default-image
				v-if="defaultHeight > 0"
				:style="`height: ${defaultHeight}px`"
			/>
		</helio-link>

		<helio-link
			v-else-if="thumbnails && thumbnails.length === 1"
			class="carousel-thumbnail__wrapper"
			:link="link"
			:aria-label="linkText"
		>
			<img
				ref="thumbnail"
				:src="src(thumbnails[0])"
				:alt="alt(thumbnails[0])"
				@load="onLoad"
			>
		</helio-link>

		<image-carousel
			v-else
			ref="thumbnail"
			class="carousel-thumbnail__wrapper"
			:images="thumbnails"
		/>

		<div
			v-if="$parent.$scopedSlots.thumbnailExtra"
			class="carousel-thumbnail__extra"
		>
			<slot name="thumbnailExtra" />
		</div>
	</div>
</template>

<script>
import DefaultImage from '../../default-image/DefaultImage.vue';
import ImageCarousel from '../image-carousel/ImageCarousel.vue';
import Link from '../../link/Link.vue';

export default {
	name: 'Thumbnail',

	components: {
		'image-carousel': ImageCarousel,
		'helio-link': Link,
		'helio-default-image': DefaultImage,
	},

	props: {
		link: {
			type: String,
			required: false,
			default: '',
			description: 'Link on image/default-image click',
		},

		linkText: {
			type: String,
			required: false,
			default: '',
			description: 'Describes link target',
		},

		thumbnails: {
			type: Array,
			required: false,
			default: null,
			description: 'Image or array of images for thumbnail. Thumbnail is not shown if property does not exists.',
		},

		defaultHeight: {
			type: Number,
			required: false,
			default: 0,
			description: 'Default height on which to fall back if we display the default image component.',
		},
	},

	mounted() {
		window.addEventListener('resize', this.onResize);
	},

	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},

	methods: {
		src(thumbnail) {
			if (typeof thumbnail === 'object') {
				return thumbnail.link;
			}

			return thumbnail;
		},

		alt(thumbnail) {
			if (typeof thumbnail === 'object') {
				return thumbnail.alt;
			}

			return '';
		},

		onResize() {
			// We add a little buffer just in case there is a delay
			// between the resize and the height adjustment
			setTimeout(() => {
				this.emitHeight();
			}, 1000);
		},

		onLoad() {
			// We add a little buffer just in case there is a delay
			// between the load event and the height adjustment
			setTimeout(() => {
				this.emitHeight();
			}, 2000);
		},

		emitHeight() {
			const { thumbnail } = this.$refs;

			if (thumbnail) {
				const { offsetHeight } = thumbnail;

				if (offsetHeight > 0) {
					this.$emit('changedDefaultHeight', offsetHeight);
					this.$forceUpdate();
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped src="./thumbnail.scss" />
